import {
  CoinIcon,
  ContractIcon,
  EmployeeIcon,
  FinanceIcon,
  GraphIcon,
  MoneyTimeIcon,
  RightIcon,
  DepartmentIcon,
  AddUserIcon,
  WalletIcon,
  TimeIcon,
  SettingsIcon,
  OpenBookIcon,
  TransferIcon,
  HammerIcon,
  LikeDislikeIcon,
  DevicesIcon,
  WarningIcon,
  UserSubstractSolidIcon,
  CardTransferSolidIcon,
  WalletMoneySolidIcon,
  CoinSolidIcon,
  MoneySolidIcon,
  TaxIcon,
  CalculateSolidIcon,
  RolledPaperSolidIcon,
  DashboardSolidIcon,
  TimeAddSolidIcon,
  TimeWarningSolidIcon,
  HolidaySolidIcon,
  CalendarCheckSolidIcon,
  CalendarEditSolidIcon,
  BuildSolidIcon,
  DepartmentSolidIcon,
  HouseSolidIcon,
  UsersSolidIcon,
  UserAddSolidIcon,
  OpenBookSolidIcon,
  WarningSolidIcon,
  HammerSolidIcon,
  ClipboardSolidIcon,
  NoteFavoriteSolidIcon,
  StatusUpSolidIcon,
  ConvertCubeSolidIcon,
  DevicesSolidIcon,
  BoxSearchSolidIcon,
  CubeScanSolidIcon,
  DocumentSolidIcon,
  ArchiveSolidIcon,
  MenuBoardSolidIcon,
  DocumentCopySolidIcon,
  ClipboardExportSolidIcon,
  EditSolidIcon,
  SettingsSolidIcon,
} from "assets/icons";
import { AiOutlinePieChart } from "react-icons/ai";
import { TbBook, TbBox, TbBrandAppgallery, TbBuildingCommunity, TbClipboardData, TbHome, TbInfoCircle, TbSettings, TbShoppingCart, TbTruckDelivery, TbUsers } from "react-icons/tb";


const extraMenu = [
    // {
    //   key: 'Мэдээлэл',
    //   icon: <TbInfoCircle/>,
    //   label: 'Мэдээлэл',
    //   formCode: 'info00',
    //   to: '/information'
    // },
  {
    key: 'Гарын авлага',
    icon: <TbBook/>,
    label: 'Гарын авлага',
    formCode: 'guide00',
    to: '/guidebook'
  },
];

const menus = [
  {
    key: "Хянах самбар",
    icon: <AiOutlinePieChart />,
    label: "Хянах самбар",
    formCode: "dash01",
    to: "/",
  },
  {
    key: "Компанийн мэдээлэл",
    label: "Компанийн мэдээлэл",
    icon: <TbBuildingCommunity />,
    formCode: 'company01',
    to: "/company",
  },
  // {
  //   key: "Байгууллага",
  //   label: "Байгууллага",
  //   icon: <TbBuildingCommunity />,
  //   formCode: "customer01",
  //   type: "accordion",
  //   children: [
  //     {
  //       key: "Компанийн мэдээлэл",
  //       label: "Компанийн мэдээлэл",
  //       icon: "-",
  //       default: true,
  //       formCode: '"customer01"',
  //       to: "/company",
  //     },
  //     {
  //     key: 'Cалбар нэгж',
  //     label: 'Cалбар нэгж',
  //     icon: '-',
  //     default: true,
  //     formCode: 'customer01',
  //     to: '/branch'
  //     },
  //   ],
  // },
  {
    key: "costumer",
    label: "Харилцагч",
    icon: <TbUsers />,
    formCode: "customer01",
    to: "/customer",
  },
  {
    key: "Ажилчид",
    label: "Ажилчид",
    icon: <TbBrandAppgallery />,
    formCode: 'user01',
    to: '/user'
  },
  {
    key: "Бараа",
    label: "Бараа",
    icon: <TbBox />,
    formCode: "product01",
    type: "accordion",
    children: [
      {
        key: "Ангилал",
        label: "Ангилал",
        icon: "-",
        formCode: "category01",
        to: "/category",
      },

      {
        key: "Барааны жагсаалт",
        label: "Барааны жагсаалт",
        icon: "-",
        default: true,
        formCode: "product01",
        to: "/products",
      },
      {
        key: "Брэнд",
        label: "Брэнд",
        icon: "-",
        formCode: "brand01",
        to: "/brand",
      },
    ],
  },
  {
    key: "Борлуулалт",
    label: "Борлуулалт",
    icon: <TbUsers />,
    formCode: "order01",
    to: "/order",
  },
  {
    key: "Агуулах",
    label: "Агуулах",
    icon: <TbHome />,
    formCode: "warehouse01",
    to: "/warehouse",
  },
  // {
  //   key: "Хүргэлт",
  //   label: "Хүргэлт",
  //   icon: <TbTruckDelivery />,
  //   formCode: "warehouse01",
  //   to: "/delivery",
  // },
  {
    key: "Татан авалт",
    label: "Татан авалт",
    icon: <TbSettings />,
    formCode: "buy01",
    type: "accordion",
    children: [
      {
        key: "Татан авалт жагсаалт",
        label: "Татан авалт жагсаалт",
        icon: "-",
        default: true,
        formCode: "buying01",
        to: "/buying",
      },

      {
        key: "Нийлүүлэгч",
        label: "Нийлүүлэгч",
        icon: "-",
        formCode: "vendor01",
        to: "/vendor",
      },
    ]
  },
  {
    key: "Тайлан",
    label: "Тайлан",
    icon: <TbClipboardData />,
    formCode: "report01",
    type: "accordion",
    children: [
      {
        key: "Ажилтны тайлан",
        label: "Ажилтны тайлан",
        icon: "-",
        formCode: "Ureport01",
        to: "/user-report",
      },
      {
        key: "Барааны тайлан",
        label: "Барааны тайлан",
        icon: "-",
        default: true,
        formCode: "Preport01",
        to: "/product-report",
      },
      {
        key: "Борлуулалтын тайлан",
        label: "Борлуулалтын тайлан",
        icon: "-",
        formCode: "Oreprot01",
        to: "/order-report",
      },
      {
        key: "Харилцагчийн тайлан",
        label: "Харилцагчийн тайлан",
        icon: "-",
        formCode: "Creport01",
        to: "/customer-report",
      },
      {
        key: "Ашиг орлогийн тайлан",
        label: "Ашиг орлогийн тайлан",
        icon: "-",
        formCode: "Boreport01",
        to: "/order-buying-report",
      },
    ]
  },
  {
    key: "Тохиргоо",
    label: "Тохиргоо",
    icon: <TbSettings />,
    formCode: "settings01",
    type: "accordion",
    children: [
      {
        key: "Системийн тохиргоо",
        label: "Системийн тохиргоо",
        icon: "-",
        default: true,
        formCode: "Ssettings01",
        to: "/settings",
      },

      {
        key: "Эрхийн тохиргоо",
        label: "Эрхийн тохиргоо",
        icon: "-",
        formCode: "Rsettings01",
        to: "/role",
      },
    ]
  },
];

export { menus, extraMenu };


    